import Vue, { defineAsyncComponent } from 'vue';

Vue.component('LoansForm', defineAsyncComponent(() => import(/* webpackChunkName: "LoansForm" */ './loans/LoansForm.vue')));
Vue.component('FeedbackFeature', defineAsyncComponent(() => import(/* webpackChunkName: "FeedbackFeature" */ '../components-manual/feedback/FeedbackFeature')));
Vue.component('HiddenLinksWrapper', defineAsyncComponent(() => import(/* webpackChunkName: "HiddenLinksWrapper" */ './HiddenLinksWrapper.vue')));
